import Image from "next/image";
import { clsx } from "clsx";
import { TestimonialType } from "@/types/TestimonialType";

export default function SwiperSlideBookingTestimonial({
  name,
  nameColor,
  countryIcon,
  countryName,
  rating,
  header,
  content,
}: TestimonialType) {
  return (
    <div className="w-full rounded-lg bg-white px-5 py-12">
      <div className="mb-7 flex items-center justify-between">
        <div className="mr-2.5 flex items-center">
          <div
            className={clsx(
              "mr-2.5 flex h-14 w-14 items-center justify-center rounded-full text-[28px]/[34px] font-medium text-white",
              nameColor,
            )}
          >
            {name.slice(0, 1)}
          </div>
          <div>
            <div className="mb-1 text-[20px]/[26px] font-bold">{name}</div>
            <div className="flex items-center">
              <Image src={countryIcon} alt={""} className="mr-2.5" />
              <span className="text-[16px]/[24px] font-medium">
                {countryName}
              </span>
            </div>
          </div>
        </div>
        <div className="mb-0 flex h-14 w-14 items-center justify-center rounded-lg rounded-bl-none bg-[#273B7D] text-[20px]/[26px] font-medium text-white">
          {rating}
        </div>
      </div>
      <div className="space-y-3">
        {header && <div className="text-[20px]/[26px] font-bold">{header}</div>}
        {content && <div className="text-[14px]/[22px]">{content}</div>}
      </div>
    </div>
  );
}
